// Copyright (c) 2025 by Audere

import { Badge, ListItemAvatar, ListItemText, styled } from "@mui/material";
import { MouseEvent, useCallback, useState } from "react";
import { green } from "@mui/material/colors";
import { useSelector } from "react-redux";
import {
  selectCurrentPatientGroupRoles,
  selectCurrentUserPersistentGroupRole,
} from "../features/slices/authSlice";
import GroupRoleMenu from "./GroupRoleMenu";
import { CustomAvatar } from "./CustomAvatar";
import { UserData } from "../features/api/labelApiSlice";

interface AnnotatorListItemProps { annotator: UserData, clickable?: boolean }

export const AnnotatorListItem: React.FC<AnnotatorListItemProps> = ({
  annotator,
  clickable = true
}) => {
  const patientGroupRoles = useSelector(selectCurrentPatientGroupRoles);
  const userGroupRole = useSelector(selectCurrentUserPersistentGroupRole);

  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null);

  const handleBadgeClick = useCallback((e: MouseEvent<HTMLDivElement>) => {
    setMenuAnchor(e.currentTarget);
    e.stopPropagation();
  }, []);

  return (
    <>
      <ListItemAvatar
        style={{ cursor: clickable ? "pointer" : "default" }}
        onClick={clickable ? handleBadgeClick : undefined}
      >
        <CustomAvatar user={annotator} />
        <GroupRoleMenu
          menuAnchor={menuAnchor}
          setMenuAnchor={setMenuAnchor}
          patientGroupRoles={patientGroupRoles ?? {}}
          persistent={userGroupRole}
        />
      </ListItemAvatar>
      <ListItemText primary={annotator.name} secondary={annotator.email} />
    </>
  );
};

// Badge with custom styles
export const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: green[500],
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    color: "white",
    fontSize: "0.5rem",
    height: "30%",
    width: "70%",
  },
}));
